import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import ComplianceBanner from "./components/ComplianceBanner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AtTheEventSection from "./components/AtTheEventSection";
import TicketsSection from "./components/TicketsSection";
import VipComparisonSection from "./components/VipComparisonSection";
import NewsletterSection from "./components/NewsletterSection";
import ContactSection from "./components/ContactSection";
import AboutSection from "./components/AboutSection";
import AgaveAmbassadorsSection from "./components/AgaveAmbassadorsSection";
import WhatToExpectSection from "./components/WhatToExpectSection";
import HomeFAQSection from "./components/HomeFAQSection";
import EarlyBirdNotifySection from "./components/EarlyBirdNotifySection";
import ResponsibleConsumptionSection from "./components/ResponsibleConsumptionSection";
import SponsorsComingSoonSection from "./components/SponsorsComingSoonSection";
import Footer from "./components/Footer";
import VendorSponsorPage from "./components/VendorSponsorPage";
import LegalPage from "./components/LegalPage";
import FAQPage from "./components/FAQPage";
import SEOLandingPage from "./components/SEOLandingPage";
import BlogIndexPage from "./components/BlogIndexPage";
import BlogPostPage from "./components/BlogPostPage";
import PressPage from "./components/PressPage";
import MobileStickyCTA from "./components/MobileStickyCTA";
import AdminBlastPage from "./components/AdminBlastPage";
import BrandGuidePage from "./components/BrandGuidePage";
import OrderPage from "./components/OrderPage";
import TequilaListPage from "./components/TequilaListPage";
import EventMapPage from "./components/EventMapPage";
import WelcomePage from "./components/WelcomePage";
import MerchandisePage from "./components/MerchandisePage";
import { ReservationCartProvider } from "./components/reservation/ReservationCartContext";
import ReservationCartButton from "./components/reservation/ReservationCartButton";
import ReservationCheckout from "./components/reservation/ReservationCheckout";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-950">
      <Helmet>
        <title>Aloha Tequila & Arts Festival 2026 | Tequila Festival in Waikiki, Oahu | June 20</title>
        <meta name="description" content="Hawaii's premier tequila festival & fundraiser — Saturday, June 20, 2026, 5–9 PM at International Market Place, Waikiki. The headline event of Oahu's Father's Day weekend (June 19–21). 80+ tequilas, mezcals & agave spirits, VIP tastings, live music, Hawaiian art & street food. Tickets selling fast. Partial proceeds benefit the Aloha Cancer Project." />
        <link rel="canonical" href="https://www.alohatequilafest.com/" />
      </Helmet>
      <ComplianceBanner />
      <Header />
      <main role="main">
        <HeroSection />
        <WhatToExpectSection />
        <AtTheEventSection />
        <TicketsSection />
        <VipComparisonSection />
        <EarlyBirdNotifySection />
        <SponsorsComingSoonSection />
        <NewsletterSection />
        <ContactSection />
        <AboutSection />
        <AgaveAmbassadorsSection />
        <HomeFAQSection />
        <ResponsibleConsumptionSection />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <ReservationCartProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/vendor-sponsor" element={<VendorSponsorPage />} />
              <Route path="/legal" element={<LegalPage />} />
              <Route path="/privacy" element={<LegalPage />} />
              <Route path="/terms" element={<LegalPage />} />
              <Route path="/refund-policy" element={<LegalPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/blog" element={<BlogIndexPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/press" element={<PressPage />} />
              <Route path="/media" element={<PressPage />} />
              <Route path="/brand-guide" element={<BrandGuidePage />} />
              <Route path="/brands" element={<BrandGuidePage />} />
              <Route path="/order" element={<OrderPage />} />
              <Route path="/tequila" element={<TequilaListPage />} />
              <Route path="/tequilas" element={<TequilaListPage />} />
              <Route path="/map" element={<EventMapPage />} />
              <Route path="/event-map" element={<EventMapPage />} />
              <Route path="/floor-map" element={<EventMapPage />} />
              <Route path="/welcome" element={<WelcomePage />} />
              <Route path="/guide" element={<WelcomePage />} />
              <Route path="/merch" element={<MerchandisePage />} />
              <Route path="/shop" element={<MerchandisePage />} />
              <Route path="/merchandise" element={<MerchandisePage />} />
              <Route path="/admin" element={<AdminBlastPage />} />
              <Route path="/admin/blast" element={<AdminBlastPage />} />
              <Route path="/things-to-do-oahu-june-2026" element={<SEOLandingPage />} />
              <Route path="/tequila-festivals-hawaii" element={<SEOLandingPage />} />
              <Route path="/honolulu-events-summer-2026" element={<SEOLandingPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
            <ReservationCartButton />
            <ReservationCheckout />
          </BrowserRouter>
        </div>
      </ReservationCartProvider>
    </HelmetProvider>
  );
}

export default App;
